import React from 'react'
import { BottomNavigation, BottomNavigationAction } from '@material-ui/core';
import { Link, useLocation } from "react-router-dom";
import MenuBookIcon from '@material-ui/icons/MenuBook';
import SettingsIcon from '@material-ui/icons/Settings';
import MapsIcon from '@material-ui/icons/Map'
import PetsIcon from '@material-ui/icons/Pets'
import { useTheme } from '@material-ui/core/styles';

const BottomNavigationCustom = () => {
  const location = useLocation()
  const theme = useTheme();

  return (
    <BottomNavigation style={{ backgroundColor: theme.palette.primary.main }}>
      <BottomNavigationAction label="Bezoeken" component={Link} to="/" style={{ color: location.pathname === "/" ? theme.palette.secondary.main : theme.palette.primary.contrastText }} icon={<MenuBookIcon />} />
      <BottomNavigationAction label="Kaart" component={Link} to="/features" style={{ color: location.pathname === "/features" ? theme.palette.secondary.main : theme.palette.primary.contrastText }} icon={<MapsIcon />} />
      <BottomNavigationAction label="Instellingen" component={Link} to="/settings" style={{ color: location.pathname === "/settings" ? theme.palette.secondary.main : theme.palette.primary.contrastText }} icon={<SettingsIcon />} />
      {parseInt(process.env.REACT_APP_PROJECTID) === 56 && 
        <BottomNavigationAction label="Waarnemingen" component={Link} to="/observations" style={{ color: location.pathname === "/observations" ? theme.palette.secondary.main : theme.palette.primary.contrastText }} icon={<PetsIcon />} />
      }
    </BottomNavigation>
  )
}

export default BottomNavigationCustom